import { type TypographyProps } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import MuiTypography from '@mui/material/Typography';

export interface ShortcutBadgeProps extends Omit<TypographyProps, 'color'> {
  /**
   * Renders the badge in the error palette — use for destructive actions
   * (e.g. "Delete"). Background becomes a translucent red tint.
   */
  isDanger?: boolean;
}

/**
 * A compact keyboard-shortcut hint badge for use inside menu items.
 * Automatically pushes itself to the right edge (`marginLeft: auto`).
 *
 * @example
 * <ShortcutBadge>E</ShortcutBadge>
 * <ShortcutBadge isDanger>Delete</ShortcutBadge>
 */
const ShortcutBadge = styled(MuiTypography, {
  shouldForwardProp: (prop) => prop !== 'isDanger',
})<ShortcutBadgeProps>(({ theme }) => ({
  marginLeft: 'auto',
  flexShrink: 0,
  padding: '2px 6px',
  borderRadius: 6,
  fontSize: 12,
  fontWeight: 700,
  lineHeight: 1.36,
  userSelect: 'none',
  backgroundColor: alpha(theme.palette.grey[0], 0.07),
  color: alpha(theme.palette.grey[0], 0.5),
}));

export default ShortcutBadge;
